// extracted by mini-css-extract-plugin
export default {"productsGroup":"ProductsGroup_productsGroup__rbUPI","productsCards":"ProductsGroup_productsCards__DiGZM"};